import blockquote, { blockquoteVariants, BlockquoteVariantsType } from './blockquote';

export const quoteVariants = {
  blockquote: blockquoteVariants
};

export interface QuoteVariantsType {
  /** The Blockquote types. */
  Blockquote: BlockquoteVariantsType;
}

const quote = {
  blockquote
};

export default quote;
